import { storeToRefs } from 'pinia';
import { useOrganizationsStore } from '@/stores/organizations';

export function useOrganizationContext() {
  const store = useOrganizationsStore();
  const {
    organizations,
    currentOrganizationId,
    currentOrganization,
    isLoading,
    error,
    hasOrganizations,
  } = storeToRefs(store);

  const initialize = async () => {
    await store.initialize();
  };

  const setCurrentOrganization = (id: string | null) => {
    store.setCurrentOrganization(id);
  };

  const refreshOrganizations = async () => {
    await store.fetchOrganizations();
  };

  return {
    // State
    organizations,
    currentOrganizationId,
    currentOrganization,
    isLoading,
    error,

    // Getters
    hasOrganizations,

    // Actions
    initialize,
    setCurrentOrganization,
    refreshOrganizations,
  };
}
